import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-content" }
const _hoisted_2 = { class: "flex flex-wrap p-5 flex-column gap-2" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "app-label" }
const _hoisted_5 = { class: "app-label" }
const _hoisted_6 = { class: "app-label" }
const _hoisted_7 = {
  class: "font-bold text-default-gray underline",
  href: "https://support.ubiant.com/contact/",
  target: "_blank"
}
const _hoisted_8 = { class: "flex flex-wrap p-5 flex-column gap-2" }
const _hoisted_9 = { class: "app-label font-bold" }
const _hoisted_10 = { class: "app-label" }
const _hoisted_11 = { class: "app-label" }
const _hoisted_12 = { class: "flex flex-wrap p-5 flex-column gap-2" }
const _hoisted_13 = { class: "app-label font-bold" }
const _hoisted_14 = { class: "app-label" }
const _hoisted_15 = { class: "app-label" }
const _hoisted_16 = { class: "app-label" }
const _hoisted_17 = { class: "flex flex-wrap p-5 flex-column gap-2" }
const _hoisted_18 = { class: "app-label font-bold" }
const _hoisted_19 = { class: "app-label" }
const _hoisted_20 = { class: "app-label" }
const _hoisted_21 = { class: "flex flex-wrap p-5 flex-column gap-2" }
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = { class: "app-label" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "app-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('top-bar-title.legal-infos')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('legal-infos.legal-1')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('legal-infos.legal-2')), 1),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('commons.contact-us')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('legal-infos.legal-3')), 1),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('legal-infos.legal-4')), 1),
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('legal-infos.legal-5')), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('legal-infos.legal-6')), 1),
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('legal-infos.legal-7')), 1),
      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('legal-infos.legal-8')), 1),
      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('legal-infos.legal-9')), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('legal-infos.legal-10')), 1),
      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('legal-infos.legal-11')), 1),
      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('legal-infos.legal-12')), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("h1", _hoisted_22, _toDisplayString(_ctx.$t('legal-infos.legal-13')), 1),
      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('legal-infos.legal-14')), 1),
      _createElementVNode("p", {
        class: "app-label",
        innerHTML: _ctx.$t('legal-infos.legal-15')
      }, null, 8, _hoisted_24),
      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('legal-infos.legal-16')), 1)
    ])
  ]))
}